var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_553_678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99974 3.95846C11.4747 3.95846 12.7956 4.46679 13.8372 5.45846L16.6914 2.60429C14.9581 0.991789 12.6956 0.00012207 9.99974 0.00012207C6.09141 0.00012207 2.71224 2.24179 1.06641 5.50846L4.39141 8.08762C5.17891 5.71679 7.39141 3.95846 9.99974 3.95846Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.575 10.2293C19.575 9.57512 19.5125 8.94179 19.4167 8.33346H10V12.0918H15.3917C15.15 13.3251 14.45 14.3751 13.4 15.0835L16.6208 17.5835C18.5 15.8418 19.575 13.2668 19.575 10.2293Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3875 11.9126C4.1875 11.3085 4.07083 10.6668 4.07083 10.0001C4.07083 9.33345 4.18333 8.69179 4.3875 8.08762L1.0625 5.50846C0.383333 6.85846 0 8.38345 0 10.0001C0 11.6168 0.383333 13.1418 1.06667 14.4918L4.3875 11.9126Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 20.0001C12.7 20.0001 14.9708 19.1126 16.6208 17.5793L13.4 15.0793C12.5042 15.6835 11.35 16.0376 10 16.0376C7.39167 16.0376 5.17917 14.2793 4.3875 11.9085L1.0625 14.4876C2.7125 17.7585 6.09167 20.0001 10 20.0001Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_553_678"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.af965fb05a91cd01b201aa1e329c4d5a.svg";
export { ForwardRef as ReactComponent };